var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { isEmpty } from "lodash";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import RewardOrdersQuery from "@irati/reward/apollo/query/RewardOrders";
import authentication from "@irati/auth";
import { H4 } from "@irati/ui/src/Headings";
import { ReactTable } from "@irati/ui/src/Table";
import Loading from "@irati/ui/src/Loading";
import Button from "@irati/ui/src/Button";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import downloadRewardLog from "@irati/admin/helpers/rewardLogCSV";
import Flex from "@irati/ui/src/Flex";
import { StyledCard } from "../../../containers/ReportingV2/styled";
import { HeaderWrapper, StyledTooltip, Error } from "../styled/styled";
import columns from "./columns/index";
var PAGE_SIZE = 20;
var RewardOrders = /** @class */ (function (_super) {
    __extends(RewardOrders, _super);
    function RewardOrders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            page: 0,
            limit: PAGE_SIZE,
            offset: 0
        };
        _this.handlePageChange = function (nextPage) {
            _this.setState({ page: nextPage });
        };
        return _this;
    }
    RewardOrders.prototype.render = function () {
        var _this = this;
        var _a = this.props.intl, formatMessage = _a.formatMessage, formatDate = _a.formatDate;
        var _b = this.state, page = _b.page, limit = _b.limit;
        var variables = { limit: 500, tenantId: authentication.userTenant().uuid };
        return (React.createElement(StyledCard, null,
            React.createElement(RewardOrdersQuery, { variables: variables }, function (_a) {
                var rewardOrders = _a.data.rewardOrders;
                var total = isEmpty(rewardOrders) ? 0 : rewardOrders.count;
                var pages = Math.ceil(total / limit);
                if (!rewardOrders.results.length) {
                    return (React.createElement(Error, null,
                        React.createElement(FormattedMessage, { id: "admin.reporting.error.empty" })));
                }
                // filter out unpopulated non existing users
                var rewardOrderResults = rewardOrders.results.map(function (reward) {
                    return __assign(__assign({}, reward), { recipients: {
                            results: reward.recipients.results.filter(function (user) { return user; })
                        } });
                });
                return (React.createElement(React.Fragment, null,
                    React.createElement(HeaderWrapper, null,
                        React.createElement(Flex, { alignItems: "center" },
                            React.createElement(H4, { bold: true },
                                React.createElement(FormattedMessage, { id: "admin.reporting.rewardOrders.heading" })),
                            React.createElement(StyledTooltip, null,
                                React.createElement(FormattedMessage, { id: "admin.reporting.rewardOrders.para" }))),
                        React.createElement(Button, { tertiary: true, onClick: function () { return downloadRewardLog(rewardOrderResults, formatMessage, formatDate); } },
                            React.createElement(FormattedMessage, { id: "admin.reporting.rewardLog.download" }),
                            React.createElement(Icon, { icon: IconTypes.downloadReport, marginLeft: true }))),
                    React.createElement(Loading, null,
                        React.createElement(ReactTable, { manual: false, getPaginationProps: function (allProps) { return (__assign(__assign({}, allProps), { shouldScrollOnUpdate: false })); }, page: page, pages: pages, onPageChange: _this.handlePageChange, showPagination: true, defaultPageSize: PAGE_SIZE, data: rewardOrderResults, onPageSizeChange: function (pageIndex) { return _this.setState({ page: 0, limit: pageIndex }); }, columns: columns(formatMessage) }))));
            })));
    };
    return RewardOrders;
}(Component));
export default injectIntl(RewardOrders);
